module.exports = __webpack_public_path__ + "img/x19.2eba7c94.jpg";